// Marca K2E (ERP, por defecto). No cambia nada respecto de antes: login de siempre,
// catálogo completo de temas y tema por defecto «clínico».
import type { Marca } from '../types';
import { LoginK2E } from '@/features/auth/LoginK2E';

export const marca: Marca = {
  id: 'k2e',
  LoginView: LoginK2E,
};
